import styled from '@emotion/styled'
import MaterialTextField, { TextFieldProps } from '@mui/material/TextField'
import { createShouldForwardProp } from '../libs/EmotionHelper'
import { ColorsDeprecated as Colors } from '../../../pure-js/libs/ColorsDeprecated'
import { getGrooverText } from '../libs/GrooverTextRepository'
import { TextKey } from '../../../pure-js/types/Antiloop'
import { PropsWithChildren } from 'react'
import { BorderRadixes } from '../enums/BorderRadixes'

export type TextFieldOutlinedProps = {
  labelTextKey?: TextKey
  placeholderTextKey?: TextKey
  pointer?: boolean
  className?: string
  Component?: React.FC<PropsWithChildren<TextFieldProps>>
} & TextFieldProps

export const TextField = (props: TextFieldOutlinedProps) => {
  const { labelTextKey, placeholderTextKey, Component = BaseTextField, ...rest } = props

  return (
    <Component
      variant="outlined"
      size="small"
      label={labelTextKey ? getGrooverText(labelTextKey) : ''}
      placeholder={placeholderTextKey ? getGrooverText(placeholderTextKey) : undefined}
      InputLabelProps={{ shrink: false }}
      {...rest}
    />
  )
}

export const TextFieldOutlined = TextField

// Is duplicated in see TextFieldOutlinedNumberInputStyles
export const BaseTextFieldStyles = `
  & .MuiOutlinedInput-notchedOutline {
    border-radius: ${BorderRadixes.small};
  }

  & legend {
    display: none;
  }

  & fieldset {
    top: 0;
  }

  background-color: white;
  cursor: pointer;
`
// Is duplicated in see BaseTextFieldStyles
export const TextFieldOutlinedNumberInputStyles = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: BorderRadixes.small,
    border: `1px solid ${Colors.neutral80}`
  },
  '& legend': {
    display: 'none'
  },

  '& fieldset': {
    top: 0
  },

  backgroundColor: 'white',
  cursor: 'pointer'
}

export const BaseTextField = styled(MaterialTextField, {
  shouldForwardProp: createShouldForwardProp('multiline')
})`
  ${BaseTextFieldStyles}
`
